/* Written by Ye Liu */

import { EventEmitter } from 'events';

export default new EventEmitter();
